import { Icon } from '@blueprintjs/core'
import { Button } from 'antd'
import { Box, Text, TextProps } from 'grommet'
import styled from 'styled-components'
import { black, blue, gray, green, white } from '../../../../ui/utils/_colors'

interface NavigateButtonProps {
  backgroundColor: string
  textColor: string
}

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1.5rem;
  padding-bottom: 80px;
  justify-content: space-between;
  height: 80%;
  // For Desktop
  max-width: 400px;
  margin: auto;
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  text-align: end;
  margin-top: 13vh;
`

export const FinalizeText = styled.p`
  color: ${blue.dark};
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  text-decoration: underline;
  margin: 0;
  inline-size: fit-content;
  border: none;
  background-color: ${white.primary};
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  &:focus {
    outline: ${blue} auto 1px;
  }
  @media only screen and (max-width: 770px) {
    margin: 28 auto;
    text-align: center;
    inline-size: none;
  }
`

export const Title = styled.span`
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 20px;
  letter-spacing: 0.18px;
  color: ${green.dark1};
`

export const SubTitle = styled.span`
  margin-top: 2vh;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.1px;
  color: #000000;
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  height: 65%;
  padding: 16px 0px 16px 0px;
  border-radius: 8px;
  border: 1px;
  border: 1px solid #f2f2f2;
  background: #ffffff;
`

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  margin-top: 10px;
`

export const CardTitle = styled.span`
  font-size: 16px;
  font-weight: 500;;
  line-height: 16px;
  color: ${gray.text};
  
  margin-top 14px;
`

export const CardValue = styled.span`
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  color: ${green.dark1};
`

export const CardRequestedValueContainer = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
`

export const CardRequestedValue = styled.span`
  font-size: 16px;
  font-weight: normal;
  line-height: 32px;
  text-decoration: line-through;
  color: #999999;
  margin-right: 5px;
`

export const StraightLine = styled.div`
  width: 100%;
  margin: 10px 0px;
  border-block: inherit;
  border-width: 1px;
  border-color: #f2f2f2;
`

export const CardInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 90%;
`

export const InfoDescription = styled.text`
  font-size: 14px;
  font-weight: 400;
  text-align-vertical: center;
  color: #999999;
`

export const InfoValue = styled(Text) <TextProps>`
  font-size: 13px;
  font-weight: 550;
  text-align-vertical: center;
  color: ${(props: TextProps) => props.color ?? gray.text};
`

export const PendingApplicationText = styled.text`
  font-size: 14px;
  font-weight: 550;
  text-align: center;
  align-items: center;
  color: #ff800b;
  background-color: #ffefe0;
  width: 150px;
  height: 33px;
  padding: 6px;
  border-radius: 8px;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`

export const AlertInfoMessage = styled.text`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  padding-left: 4px;
  color: #999999;
`

export const AlertInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 90%;
  margin: 20px 0px;
`

export const Subtitle = styled.text`
  font-size: 14px;
  font-weight: 700;
  text-align: left;
  font-weight: bold;
  line-height: 20px;
  padding-bottom: 10px;
`

export const InstallmentsText = styled.text`
  color: ${gray.muted};
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
`

export const InstallmentsValueText = styled.text`
  color: ${black.text};
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
`

export const BoldText = styled.span`
  font-weight: 525;
  color: black;
`

export const TableWrapper = styled.div`
  margin: 10px 0px;
`

export const TableRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 90%;
  padding-left: 5px;
  padding-right: 5px;
`

export const TableData = styled(Box)`
  border: 1px solid ${gray.light3} !important;
  display: flex;
  flex-direction: row;
  justify-content: center;
`

export const NavigateButton = styled(Button) <NavigateButtonProps>`
  // TEXT
  font-family: Roboto !important;
  font-style: normal !important;
  font-weight: bold !important;
  font-size: 14px !important;
  line-height: 16px !important;
  text-align: center !important;
  color: ${(props: NavigateButtonProps) => props.textColor} !important;
  // BUTTON
  height: 80px !important;
  padding: 20px !important;
  border: 1px solid ${green.dark1} !important;
  background: ${(props: NavigateButtonProps) => props.backgroundColor} !important;
  border-radius: 10px !important;
  width: 100% !important;
  margin: 0px;
  align-self: center;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
`

export const ShowSimulationIcon = styled(Icon)`
  margin-left: 8px;
`

export const ShowSimulationText = styled.p`
  color: ${green.dark1};
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  text-decoration: underline;
  margin: 0;
  inline-size: fit-content;
  border: none;
  background-color: ${white.primary};
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  &:focus {
    outline: ${blue} auto 1px;
  }
  @media only screen and (max-width: 770px) {
    margin: 28 auto;
    text-align: center;
    inline-size: none;
  }
`
